import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

export const BadgesSection = () => {
    const intl = useIntl();
    return (
        <UFOSegment name="enterprise-page-badges">
            <div css={badgeSectionStyles}>
                <div className="eyebrow-md" css={divStyles}>
                    <FormattedMessage
                        id="EnterpriseLandingPage.badges.eyebrow"
                        defaultMessage="Recognized by world-class analysts"
                    />
                </div>
                <Row layout="3-3-3-3">
                    <Badge
                        href={useLocalizedHref(
                            "/forrester/wave-enterprise-service-management"
                        )}
                        imageUrl="https://wac-cdn.atlassian.com/misc-assets/webp-images/forrester_wave_leader_2023-3286669196.webp"
                        imageAlt=""
                        badgeText={intl.formatMessage({
                            id: "EnterpriseLandingPage.badges.badge1",
                            defaultMessage:
                                "Atlassian is a Leader in The Forrester Wave™: Enterprise Service Management, Q4 2023."
                        })}
                        badgeLabel="Atlassian is a Leader in The Forrester Wave™: Enterprise Service Management, Q4 2023."
                    />
                    <Badge
                        imageUrl="https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg"
                        imageAlt=""
                        badgeText={intl.formatMessage({
                            id: "EnterpriseLandingPage.badges.badge2",
                            defaultMessage:
                                "A Leader in the 2023 Gartner® Magic Quadrant™ for DevOps Platforms*"
                        })}
                    />
                    <Badge
                        imageUrl="https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg"
                        imageAlt=""
                        badgeText={intl.formatMessage({
                            id: "EnterpriseLandingPage.badges.badge3",
                            defaultMessage:
                                "A Leader in the 2023 Gartner® Magic Quadrant™ for Enterprise Agile Planning Tools*"
                        })}
                    />
                    <Badge
                        imageUrl="https://wac-cdn.atlassian.com/misc-assets/webp-images/Peer-Insights-Customers-Choice-2023.svg"
                        imageAlt=""
                        badgeText={intl.formatMessage({
                            id: "EnterpriseLandingPage.badges.badge4",
                            defaultMessage:
                                "A Gartner® Peer Insights™ Customers' Choice for Enterprise Agile Planning Tools."
                        })}
                    />
                </Row>
            </div>
        </UFOSegment>
    );
};

const badgeSectionStyles = css({
    marginBlockEnd: "75px"
});

const divStyles = css({
    textAlign: "center",
    marginBlockEnd: "10px"
});

interface BadgeProps {
    href?: string;
    imageUrl: string;
    imageAlt: string;
    badgeText: string;
    badgeLabel?: string;
}
const Badge = ({
    href,
    imageUrl,
    imageAlt,
    badgeText,
    badgeLabel
}: BadgeProps) => {
    return (
        <div css={BadgeStyles}>
            <a
                href={href}
                data-product-key="enterprise"
                data-event-component="link"
                data-event-container="badgesSection"
                data-event="clicked"
                data-label={badgeText}
                data-label-english={badgeLabel}
            >
                <div className="image-container">
                    <img src={imageUrl} alt={imageAlt} />
                </div>
                <div className="badge-text body-sm">{badgeText}</div>
            </a>
        </div>
    );
};

const BadgeStyles = css({
    ".image-container": {
        height: "100px",
        img: {
            maxHeight: "80px",
            display: "block",
            marginInlineStart: "auto",
            marginInlineEnd: "auto",
            marginBlockStart: "15px",
            marginBlockEnd: "15px"
        }
    },
    ".badge-text": {
        textAlign: "center"
    }
});
